"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const progress_indicator_circular_1 = require("@andes/progress-indicator-circular");
const useGoogleOAuth_1 = __importDefault(require("../../hooks/useGoogleOAuth"));
const useGoogleCredential_1 = __importDefault(require("../../hooks/useGoogleCredential"));
const tracks_1 = require("../../../services/tracks");
const utils_1 = require("../../../utils");
const GoogleButton = ({ onSuccess, onError, buttonConfig, navigation, featureFlags, scope, trackingId, ...props }) => {
    const { type, theme, size, text, shape, logo_alignment: logoAlignment, width, locale, click_listener: clickListener, } = buttonConfig || {};
    const btnContainerRef = (0, react_1.useRef)(null);
    const { clientId, scriptLoadedSuccessfully } = (0, useGoogleOAuth_1.default)();
    const trackSubmit = (credentialResponse) => {
        const selectBy = credentialResponse.select_by;
        const context = {
            navigation: {
                ...navigation,
                select_by: selectBy,
            },
            trackingId,
        };
        const trackKey = (0, utils_1.isGoogleButton)(selectBy)
            ? tracks_1.TRACK_KEY.GOOGLE_AUTH_BUTTON_CLICK
            : tracks_1.TRACK_KEY.GOOGLE_AUTH_ONE_TAP_CLICK;
        const data = (0, tracks_1.getTrackingData)(trackKey, context);
        (0, tracks_1.trackEvent)(data);
    };
    const { handleSubmit } = (0, useGoogleCredential_1.default)({ scope, onSuccess, onError });
    const handleCredentialResponse = (credentialResponse) => {
        trackSubmit(credentialResponse);
        handleSubmit(credentialResponse, navigation);
    };
    const googleInitialize = () => {
        window.google?.accounts.id.initialize({
            client_id: clientId,
            callback: handleCredentialResponse,
            use_fedcm_for_prompt: true,
            itp_support: true,
            cancel_on_tap_outside: false,
            ...props,
        });
    };
    const googleRenderButton = () => {
        window.google?.accounts.id.renderButton(btnContainerRef.current, {
            type,
            theme,
            size,
            text,
            shape,
            logo_alignment: logoAlignment,
            width,
            locale,
            click_listener: clickListener,
        });
    };
    const googleRenderOneTap = () => {
        window.google?.accounts.id.prompt();
    };
    (0, react_1.useEffect)(() => {
        if (scriptLoadedSuccessfully) {
            googleInitialize();
            if (featureFlags?.googleButton)
                googleRenderButton();
            if (featureFlags?.googleOneTap)
                googleRenderOneTap();
        }
    }, [
        clientId,
        scriptLoadedSuccessfully,
        type,
        theme,
        size,
        text,
        shape,
        logoAlignment,
        width,
        locale,
        clickListener,
    ]);
    return (featureFlags?.googleButton && ((0, jsx_runtime_1.jsx)("div", { ref: btnContainerRef, className: "google-button", children: (0, jsx_runtime_1.jsx)("div", { className: "google-button__container", children: (0, jsx_runtime_1.jsx)("div", { className: "google-button__content", children: (0, jsx_runtime_1.jsx)(progress_indicator_circular_1.ProgressIndicatorCircular, { className: "google-button__spinner", size: "xsmall", color: "blue", modifier: "block" }) }) }) })));
};
exports.default = GoogleButton;
